import { Upload, message } from 'antd';
import { useSelector } from 'react-redux';
import { AuthState } from '../../store/reducer/auth';

type Props = {
  children?: React.ReactNode;
};
const FileUpload = ({ children }: Props) => {
  const { accessToken } = useSelector((state: { auth: AuthState }) => state?.auth);
  const [messageApi, contextHolder] = message.useMessage();

  const customUpload = async ({ file, onSuccess, onError }: any) => {
    try {
      // API руу илгээх
      const formData = new FormData();
      formData.append('file', file);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/media/upload`, {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (res.ok) {
        onSuccess('ok');
        messageApi.open({
          type: 'success',
          content: 'Амжилттай!',
        });
      } else {
        onError('Upload failed');
      }
    } catch (err) {
      onError(err);
    }
  };

  return (
    <>
      {contextHolder}
      <Upload
        name="file"
        multiple={false}
        customRequest={customUpload}
        showUploadList={false}
        accept=".xlsx"
        onChange={(info) => {
          if (info.file.status === 'done') {
            message.success(`${info.file.name} uploaded successfully`);
          } else if (info.file.status === 'error') {
            message.error(`${info.file.name} upload failed.`);
          }
        }}
      >
        {children}
      </Upload>
    </>
  );
};

export { FileUpload };
